// extracted by mini-css-extract-plugin
module.exports = {"text":"_9400a595a7--text--MSVrO"};